import React from 'react';

import { adlessCommand, adlessQuery, commandResponse } from '.';
import { EnrollRequest, EnrollResponse, ListEnrollmentsResponse, UnenrollRequest, UnenrollResponse } from './gen/earner';

export default {
    list: () => adlessQuery<ListEnrollmentsResponse>("/v1/earner/list"),
    enroll: (req: EnrollRequest) => adlessCommand<EnrollResponse>("/v1/earner/enroll", req),
    unenroll: (req: UnenrollRequest) => adlessCommand<UnenrollResponse>("/v1/earner/unenroll", req),
}